import React, { forwardRef, memo } from "react";
import { TableContainer, TableContainerProps } from "@mui/material";
import clsx from "clsx";
const AppTableContainer = forwardRef<
  HTMLDivElement,
  Omit<TableContainerProps, "ref">
>(({ children, className, sx, ...otherProps }, ref) => {
  return (
    <TableContainer
      className={clsx("custom-scrollbar table", className)}
      sx={{
        ...sx,
      }}
      ref={ref}
      {...otherProps}
    >
      {children}
    </TableContainer>
  );
});
AppTableContainer.displayName = "AppTableContainer";
export default memo(AppTableContainer);
